import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './HeaderApplication.css';

class HeaderApplication extends Component {
  render() {
    const { applicationPage } = this.props;
    const checkImg =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/check.png';
    const number2 =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/number-2.png';
    const number3 =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/number-3.png';
    const arrowBlue =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/arrow-blue.svg';
    const arrowGrey =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/arrow-grey.svg';
    const arrowFull =
      'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/arrow-blue-full.svg';

    const header = (
      <table className={styles['container-nav-bar']}>
        <tr>
          <td className={`${styles['select-blue']} ${styles['first-step']}`}>
            <img src={checkImg} className={``} />
          </td>
          <td className={`${styles['select-blue']}`}>
            <h4>Loan Application</h4>
            <p>Select Lender</p>
          </td>
          <td className={`${styles['image-arrow']}`}>
            <img src={applicationPage === 1 ? arrowBlue : arrowFull} />
          </td>
          <td
            className={`${
              applicationPage === 1
                ? styles['select-white']
                : styles['select-blue']
            }`}
          >
            <img
              src={applicationPage >= 2 ? checkImg : number2}
              className={``}
            />
          </td>
          <td
            className={`${
              applicationPage === 1
                ? styles['select-white']
                : styles['select-blue']
            }`}
          >
            <h4>Document Upload</h4>
            <p>Upload Required Docs</p>
          </td>
          <td className={`${styles['image-arrow']}`}>
            <img
              src={
                applicationPage === 1
                  ? arrowGrey
                  : applicationPage === 3
                  ? arrowFull
                  : arrowBlue
              }
            />
          </td>
          <td
            className={`${
              applicationPage === 3
                ? styles['select-blue']
                : styles['select-white']
            }`}
          >
            <img
              src={applicationPage === 3 ? checkImg : number3}
              className={`${styles['img-status']}`}
            />
          </td>
          <td
            className={`${
              applicationPage === 3
                ? styles['select-blue']
                : styles['select-white']
            } ${styles['final-arrow']}`}
          >
            <h4>Final Approval</h4>
            <p>Loan Finalization</p>
          </td>
        </tr>
      </table>
    );
    return (
      <div className={`row ${styles['body-container']}`}>
        <div className={`row ${styles['row-padding']}`}>
          {applicationPage !== 4 && header}
        </div>
      </div>
    );
  }

  _onClickTryLoyalty = () => {
    this.props.goToSubscribeView();
  };
}

HeaderApplication.propTypes = {
  goToSubscribeView: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { applicationPage } = state.capital;
  return {
    applicationPage,
  };
}

export default connect(mapStateToProps)(HeaderApplication);
